import { Box, Icon } from '@zillow/constellation-10';
import { IconLightBulbFilled } from '@zillow/constellation-icons';

import { AppSelectors } from '../../selectors';
import { useSelector } from '../../selectors/useSelector';

const getAriaDescribedBy = (fieldName: string): string | undefined =>
  fieldName ? `learn-more-about-${fieldName}` : undefined;

type Props = {
  onClick: () => void;
  removeFlex?: boolean;
  fieldName?: string;
  dataEventid?: string;
};

const RecommendationIconBulb = ({ onClick, removeFlex = false, fieldName = '', dataEventid = '' }: Props) => {
  const isScreenLgGTE = useSelector((state) => AppSelectors.makeIsScreenLgGTE(state));

  if (removeFlex) {
    return (
      <Icon
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        css={{ color: 'icon.accent.brand.hero', marginRight: '200', cursor: 'pointer' }}
        size="sm"
        render={<IconLightBulbFilled />}
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </Icon>
    );
  }

  return (
    <Box css={{ display: 'flex' }}>
      <Icon
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        css={{
          color: 'icon.accent.brand.hero',
          marginRight: '200',
          marginLeft: isScreenLgGTE ? 'spacing.-100' : '0',
          cursor: 'pointer',
        }}
        size="md"
        render={<IconLightBulbFilled />}
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </Icon>
    </Box>
  );
};

export default RecommendationIconBulb;
